<template>
  <div id="app" :class="{ connect: this.$route.meta.requiresAuth}">
    <navigation v-if="this.$route.meta.requiresAuth"/>
    <section class="main-view">
      <breadcrumb v-if="this.$route.meta.requiresAuth"></breadcrumb>
      <router-view/>
    </section>
  </div>
</template>

<script>
import Navigation from '@/components/layouts/Navigation.vue';
import Breadcrumb from '@/components/layouts/Breadcrumb.vue';

export default {
  name: 'app',
  components: {
    Navigation,
    Breadcrumb,
  },
};
</script>

<style lang="sass">
html, body
  margin: 0
  padding: 0
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50

a
  text-decoration: none
  color: inherit

*
  box-sizing: border-box

.main-view
  padding: 3em 2rem 1rem 2rem
  min-height: 100vh
  background: #f8f8f8

  h1
    text-align: left

  .g-container
    display: flex
    padding: 0.4rem 0
    align-items: center
    flex-wrap: wrap

.connect
  .main-view
    margin-left: 200px

.material-icons
  display: inline-block
  font-family: 'Material Icons'
  font-weight: normal
  font-style: normal
  font-size: 24px
  line-height: 1
  text-transform: none
  letter-spacing: normal
  word-wrap: normal
  white-space: nowrap
  direction: ltr
  vertical-align: middle

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale

  /* Support for IE. */
  font-feature-settings: 'liga'

.el-notification.right
  right: 50%
  margin-right: -200px
  .el-notification__title, p
    font-size: 0.8rem

</style>
